<template>
  <div class="warehouse">
    <div class="title" v-if="mark">{{ mark }}</div>
    <div v-if="$route.params.type == 1" class="addressInfo" @click="addressTap">
      <div class="info acea-row row-between-wrapper" v-if="address.id">
        <div class="infos">
          <div class="acea-row name">
            <span class="nickname">{{ address.real_name }}</span>
            <span class="mobile">{{ address.phone }}</span>
          </div>
          <div class="acea-row add">
            {{ address.province }}
            {{ address.city }}
            {{ address.district }}
            {{ address.detail }}
          </div>
        </div>
        <i class="iconfont icon-jiantou"></i>
      </div>
      <div class="acea-row row-middle" v-else>
        <i class="iconfont icon-dizhi"></i>
        <span>请选择收货地址</span>
      </div>
    </div>
    <div class="list">
      <div class="item acea-row row-middle">
        <img :src="infos.image" alt="" />
        <div class="infos">
          <div class="store_name">{{ infos.store_name }}</div>
          <div class="rule">{{ infos.suk }}</div>
          <div class="num">库存：{{ infos.num }}</div>
        </div>
      </div>
    </div>
    <div v-if="$route.params.type == 2" class="cont">
      <div class="item acea-row row-middle">
        <div class="label">对方账号：</div>
        <input v-model="account" type="text" placeholder="请输入对方账户" />
      </div>
    </div>
    <div class="cont">
      <div class="item acea-row row-middle">
        <div class="label">数量：</div>
        <input v-model="num" type="number" placeholder="请输入数量" />
      </div>
    </div>
    <div v-if="$route.params.type == 2" class="cont">
      <div class="item acea-row row-middle">
        <div class="label">交易密码：</div>
        <input v-model="pwd" type="password" placeholder="请输入交易密码" />
      </div>
    </div>
    <div @click="submit" v-if="$route.params.type == 1" class="submit">
      提货
    </div>
    <div @click="submit2" v-else-if="$route.params.type == 4" class="submit">
      云仓自提
    </div>
    <div @click="submit1" v-else class="submit">云仓互转</div>
    <AddressWindow
      @checked="changeAddress"
      @redirect="addressRedirect"
      v-model="showAddress"
      :checked="address.id"
      ref="mychild"
    ></AddressWindow>
  </div>
</template>
<script>
import AddressWindow from "@components/AddressWindow";
import {
  stockDetails,
  stockExtract,
  transferStock,
  stockZt
} from "../../api/order";
export default {
  name: "warehouse",
  components: {
    AddressWindow
  },
  data() {
    return {
      page: 1,
      num: "",
      limit: 10,
      pwd: "",
      account: "",
      address: {},
      loading: false,
      loadend: false,
      addressLoaded: false,
      showAddress: false,
      infos: {},
      mark: "",
      yc_type: 0,
      id: ""
    };
  },
  mounted() {
    this.yc_type = this.$route.query.yc_type;
    if (this.$route.params.id) {
      this.id = this.$route.params.id;
      this.getdetail();
    } else {
      this.$dialog.toast({ mes: "缺少参数!" });
      setTimeout(() => {
        this.$router.gp(-1);
      }, 1500);
    }
  },
  methods: {
    submit2() {
      if (!this.num) {
        return this.$dialog.toast({ mes: "请输入自提货数量!" });
      }
      let data = {
        num: this.num,
        pid: this.infos.pid,
        unique: this.infos.unique,
        yc_type: this.yc_type
      };
      stockZt(data)
        .then(res => {
          console.log(res);
          this.$dialog.toast({ mes: res.msg });
          setTimeout(() => {
            this.$router.push("/order/detail/" + res.data.order_id);
          }, 1500);
        })
        .catch(res => {
          this.$dialog.toast({ mes: res.msg });
          console.log(res);
        });
    },
    submit1() {
      if (!this.num) {
        return this.$dialog.toast({ mes: "请输入提货数量!" });
      }
      if (!this.account) {
        return this.$dialog.toast({ mes: "请输入对方账号!" });
      }
      if (!this.pwd) {
        return this.$dialog.toast({ mes: "请输入交易密码!" });
      }
      let data = {
        zr_account: this.account,
        num: this.num,
        pid: this.infos.pid,
        pwd_pay: this.pwd,
        unique: this.infos.unique,
        yc_type: this.yc_type
      };
      transferStock(data)
        .then(res => {
          console.log(res);
          this.$dialog.toast({ mes: res.msg });
          setTimeout(() => {
            this.$router.go(-1);
          }, 1500);
        })
        .catch(res => {
          this.$dialog.toast({ mes: res.msg });
          console.log(res);
        });
    },
    submit() {
      if (!this.num) {
        return this.$dialog.toast({ mes: "请输入提货数量!" });
      }
      if (!this.address.id) {
        return this.$dialog.toast({ mes: "请选择收货地址" });
      }
      let data = {
        num: this.num,
        addressId: this.address.id,
        pid: this.infos.pid,
        unique: this.infos.unique,
        yc_type: this.yc_type
      };
      stockExtract(data)
        .then(res => {
          console.log(res);
          this.$dialog.toast({ mes: res.msg });
          setTimeout(() => {
            this.$router.push("/order/detail/" + res.data.order_id);
          }, 1500);
        })
        .catch(res => {
          this.$dialog.toast({ mes: res.msg });
          console.log(res);
        });
    },
    changeAddress(addressInfo) {
      this.address = addressInfo;
    },
    addressTap: function() {
      this.showAddress = true;
      if (!this.addressLoaded) {
        this.addressLoaded = true;
        this.$refs.mychild.getAddressList();
      }
    },
    getdetail() {
      stockDetails({ id: this.id, yc_type: this.yc_type })
        .then(res => {
          console.log(res);
          this.infos = res.data.data;
          this.address = res.data.addr;
          this.mark = res.data.mark;
        })
        .catch(res => {
          console.log(res);
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.warehouse {
  .addressInfo {
    padding: 2vw 4vw;
    margin-bottom: 3vw;
    .info {
      background: #ffffff;
      padding: 0 2vw;
      .infos {
        .name {
          height: 8vw;
          line-height: 8vw;
          .nickname {
            margin-right: 3vw;
          }
        }
        .add {
          line-height: 8vw;
          font-size: 4vw;
          color: #000;
        }
      }
    }
  }
  .list {
    padding: 0 4vw;
    .item {
      padding: 3vw 2vw;
      background: #ffffff;
      border-radius: 2vw;
      margin-bottom: 3vw;
      img {
        width: 15vw;
        height: 15vw;
        margin-right: 2vw;
      }
      .infos {
        .store_name {
          font-size: 4vw;
          font-weight: 600;
        }
        .rule {
          font-size: 3.73vw;
        }
        .num {
          color: #666;
          color: #999;
        }
      }
    }
  }
  .cont {
    padding: 2vw 4vw;
    .item {
      background: #ffffff;
      padding: 0 2vw;
      height: 12vw;
      line-height: 12vw;
    }
  }
  .submit {
    width: 92vw;
    line-height: 12vw;
    height: 12vw;
    text-align: center;
    color: #ffffff;
    background: #0e98fd;
    border-radius: 6vw;
    margin: 10vw 4vw 0;
  }
}
.title {
  height: 0.8rem;
  width: 100%;
  background-color: #0e98fd;
  line-height: 0.8rem;
  text-align: center;
  margin-bottom: 0.2rem;
  color: #fff;
}
</style>
